var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestInActive2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1420_37061)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_1420_37061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.04 26.6278C29.4953 27.077 29.4953 27.8118 29.04 28.261C28.5934 28.7015 27.8757 28.7015 27.429 28.261L25.2012 26.0634V34.3333C25.2012 34.9776 24.6788 35.5 24.0345 35.5C23.3902 35.5 22.8678 34.9776 22.8678 34.3333V26.0634L20.64 28.261C20.1934 28.7015 19.4757 28.7015 19.029 28.261C18.5737 27.8118 18.5737 27.077 19.029 26.6278L24.0345 21.6904L29.04 26.6278Z",
    fill: "#E87A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1757 34.2518C14.8417 34.7608 14.1716 34.9258 13.6395 34.63L8.16667 31.5873C7.46667 31.127 7 30.4365 7 29.631V15.5913C7 14.7857 7.46667 13.9802 8.16667 13.6349L19.8333 6.84524C20.1833 6.61508 20.5333 6.5 21 6.5C21.4667 6.5 21.8167 6.61508 22.1667 6.84524L33.8333 13.6349C34.5333 14.0952 35 14.7857 35 15.5913V21.4444C35 22.0888 34.4777 22.6111 33.8333 22.6111C33.189 22.6111 32.6667 22.0888 32.6667 21.4444V15.5913L21 8.80159L9.33333 15.5913V29.631L14.761 32.5947C15.3566 32.9199 15.5479 33.6843 15.1757 34.2518Z",
    fill: "url(#paint1_linear_1420_37061)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1420_37061",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1420_37061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1420_37061",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1420_37061",
    x1: 41,
    y1: 21,
    x2: 0.999999,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1420_37061",
    x1: 35,
    y1: 20.8274,
    x2: 7,
    y2: 20.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1245"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestInActive2);
export default __webpack_public_path__ + "static/media/RequestInActive2.990ca88113b6d6f72801cf398578a185.svg";
export { ForwardRef as ReactComponent };